import React from 'react';
import { inspectionFlow } from '../data/content';
export function SystemOverview() {
  return <section className="blueprint-grid bg-ink px-3 py-4 text-white sm:px-6" data-id="element-170" data-mp="18vski2oh9av8">
      <div className="mx-auto max-w-2xl text-center" data-id="element-171" data-mp="1mmnujiappy0e">
        <h2 className="font-display text-[1.35rem] font-extrabold uppercase leading-none sm:text-[1.85rem]" data-id="element-172" data-mp="1mm5qw0lq0hig">
          EVERYTHING YOU NEED.{' '}
          <span className="text-hazard" data-id="element-173" data-mp="ty02n3vgkadv">ONE COMPLETE CONSTRUCTION SITE MANAGEMENT SYSTEM.</span>
        </h2>
        <p className="mt-1 font-display text-[0.76rem] font-bold text-steel sm:text-[0.9rem]" data-id="element-174" data-mp="pwod0ycl3p5o">
          6 Professional Construction Management Modules In One Organized System
        </p>
        <p className="mt-2 font-display text-[1.05rem] font-extrabold uppercase text-hazard sm:text-[1.3rem]" data-id="element-175" data-mp="yx30o4d0tgcc">
          🏗️ CONSTRUCTION SITE PRO™
        </p>
        <p className="mt-1 text-[0.78rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-176" data-mp="2f9ru37r1dk4s">
          CONSTRUCTION SITE PRO™ brings daily site planning, workforce coordination, materials and
          equipment tracking, construction progress monitoring, operational inspections, and
          professional reporting together in one practical, ready-to-use system.
        </p>
        <p className="mt-2 inline-block rounded border border-line bg-graphite px-2.5 py-1 font-display text-[0.56rem] font-extrabold uppercase text-white sm:text-[0.78rem]" data-id="element-177" data-mp="2d5lgzdcrru9n">
          {inspectionFlow.map((step, i) => <React.Fragment key={step} data-id="element-178" data-mp="1khfx0stji9av" data-mpi={i}>
              {i > 0 ? <span className="text-hazard" data-id="element-179" data-mp="1pepqqknyp74i"> → </span> : null}
              {step}
            </React.Fragment>)}
        </p>
      </div>
    </section>;
}